<template>
<div
  v-if="loading"
  :ui="realUi"
  :class="$c('loading')"
>
  <div
    :ui="realUi"
    :class="$c('loading-spinner')"
  >
    <slot name="spinner">
      <veui-icon
        spin
        :name="icons.loading"
      />
    </slot>
  </div>
  <div
    v-if="$slots.default"
    :ui="realUi"
    :class="$c('loading-text')"
  >
    <slot/>
  </div>
</div>
</template>
<script>
import 'veui/locale/zh-Hans/common.js'
import 'veui/locale/en-US/common.js'
import 'veui-theme-dls/components/Loading.js'

import Icon from './Icon'
import prefix from '../mixins/prefix'
import ui from '../mixins/ui'

export default {
  name: 'veui-loading',
  components: {
    'veui-icon': Icon
  },
  mixins: [prefix, ui],
  props: {
    loading: Boolean
  }
}
</script>
<style lang="less" src="veui-theme-dls/components/loading.less"></style>
